import React from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {FaStar, FaStarHalfAlt, FaRegStar} from "react-icons/fa";

const RatingStars = ({rating}) => {
    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.5;
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

        for (let i = 0; i < fullStars; i++) {
            stars.push(<FaStar key={`full-${i}`} color="#f6ad55"/>); // orange
        }
        if (hasHalfStar) {
            stars.push(<FaStarHalfAlt key="half" color="#f6ad55"/>);
        }
        for (let i = 0; i < emptyStars; i++) {
            stars.push(<FaRegStar key={`empty-${i}`} color="#f6ad55"/>);
        }

        return <Flex gap={0.5}>{stars}</Flex>;
    };

    return (
        <Box>
            {renderStars(rating)}
        </Box>
    );
};

export default RatingStars;
